export class StatusError extends Error {
	status: number;
	constructor(statusCode: number, ...args: any) {
		super(...args);
		this.status = statusCode;
	}
}

export class CodeError extends Error {
	code: string | number;
	constructor(code: string | number, ...args: any) {
		super(...args);
		this.code = code;
	}
}

/**
 * An error whose `message` is already localized copy, safe to show a user.
 *
 * Everything else that reaches a `catch` block carries text we must not
 * render: `helpers/api` puts the backend's English response body in
 * `message` so it lands in Sentry, and hand-rolled `throw new Error(...)`
 * sites carry developer strings. `helpers/errorMessage` tells the two apart
 * by type, so a thrower that wants its message shown verbatim has to say so
 * by throwing this instead of a bare `Error`.
 */
export class LocalizedError extends Error {}

/**
 * A 4xx is the server's final answer: the request itself is wrong, so repeating
 * it verbatim can only fail the same way. Retrying one just holds the caller on
 * a spinner for the length of the backoff.
 *
 * 429 is the exception. It says "not now" rather than "not ever", which is
 * precisely what backing off and retrying is for.
 */
export const isClientError = (error: unknown): boolean =>
	error instanceof StatusError && error.status >= 400 && error.status < 500 && error.status !== 429;
